import * as React from "react";
import {cx}       from "emotion";

import "./uyo.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Invoke}         from "@Common/react/invoke";
import {UseRef}         from "@Common/react/use-ref";
import {AlertModal}     from "@Common/ui-components/heavy/common/design2/dialogs/alert-modal/alert-modal";

import {UyoModal} from "./uyo-modal/uyo-modal";


export const UYO = ({templateOptions, item, view, gallery, customizeStatus, eh, domRef, prepareSave}) => cs(
    consumeContext("systemConstants"),
    ["uyoModal", ({}, next) => UyoModal({
        templateOptions,
        item,
        view,
        gallery,
        customizeStatus,
        next,
    })],
    ["alertModal", (_, next) => AlertModal({next})],
    ["uploadRef", (_, next) => UseRef({next})],
    // assign the image asset to start validating upon loading the view - this happens when a template uses multipage
    // validation but the order was created against it before multipage validation was implemented
    ["promptImageAssetId", (_, next) => next(
        (item && item.uyoMPB && !item.metaData.pdfValidation?.issues && item.metaData.pdfValidation?.imageAssetId) ?? 0
    )],
    ({systemConstants, uyoModal, alertModal, uploadRef, promptImageAssetId}) => (
        <div className={cx("uyo-8d3 section", eh.css)} ref={domRef.set}>
            <div className="header">
                <div className="title" xd-qa-type="label" xd-qa-name="Upload Your Brochure File">
                    Upload Your Brochure File
                </div>
            </div>
            {cs(
                ({}, next) => !!promptImageAssetId ? Invoke({
                    action: () => {
                        uyoModal.show({imageAssetId: promptImageAssetId, prepareSave});
                    },
                    next
                }) : next(),
                ({}) => (
                    <div className="actions">
                        <button className="upload-button"
                            onClick={() => uploadRef.get().click()}
                            xd-qa-type="button"
                            xd-qa-name={item?.metaData?.pdfValidation?.fileName ? "Choose a different file..." : "Browse..."}
                        >
                            {item?.metaData?.pdfValidation?.fileName ? "Choose a different file..." : "Browse..."}
                        </button>
                        <input type="file"
                            ref={ref => uploadRef.set(ref)}
                            id="fileUpload"
                            style={{display: "none"}}
                            xd-qa-type="file_input" xd-qa-name="Fileupload"
                            accept=".pdf"
                            onChange={async (event) => {
                                const file = event.target.files[0];
                                if (file) {
                                    const fileName = file.name.toLowerCase();
                                    if (!fileName.endsWith('.pdf')) {
                                        await alertModal.show({
                                            message: "Please select a valid PDF file.",
                                        });
                                    } else if (file.size > systemConstants?.value?.UPLOAD_MAX_CHUNKED_UPLOAD) {
                                        await alertModal.show({
                                            message: "File size is too large",
                                            description: `File size must be under ${parseInt(systemConstants?.value?.UPLOAD_MAX_CHUNKED_UPLOAD) / 1000000} MB`,
                                        });
                                    } else {
                                        uyoModal.show({file, prepareSave})
                                    }
                                }
                            }}
                        />
                        <div className="file-name"
                            xd-qa-type="text"
                            xd-qa-name={item?.metaData?.pdfValidation?.fileName && item?.metaData?.pdfValidation?.fileName}
                        >
                            {item?.metaData?.pdfValidation?.fileName && item?.metaData?.pdfValidation?.fileName}
                        </div>
                    </div>
                ),
            )}
        </div>
    )
);
